import type { Restaurant } from "api-types";
import { AxiosInstance } from "axios";

import { type UseMutationResult, useMutation } from "react-query";

import { useAxiosClient } from "igfd-commons/src/http";

// The featureFlags entries the restaurants service lets managers set.
export type UpdateRestaurantFeatureFlagVariables = {
  flagName: "useGuestMenuV2";
  flagValue: "true" | "false";
};

// The restaurant comes from the x-restaurant-uuid header (set by the axios
// provider); the response is the saved restaurant.
export const useUpdateRestaurantFeatureFlagMutation = (): UseMutationResult<
  Restaurant,
  Error,
  UpdateRestaurantFeatureFlagVariables
> => {
  const client: AxiosInstance = useAxiosClient({ withAuth: true });

  return useMutation(async (flag: UpdateRestaurantFeatureFlagVariables) => {
    const { data } = await client.post<Restaurant>(
      "/restaurants/auth/update-restaurant-feature-flag",
      flag,
      {
        validateStatus: (status) => status === 200,
      }
    );
    return data;
  });
};
